// The home page once sign-up is open (web/home.html): the waitlist page with Start free with Google in place of
// its forms. Shown at / to anyone signed out (server/app.ts).
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import WaitlistPage from './features/waitlist/WaitlistPage';
import '@fontsource/atkinson-hyperlegible/400.css';
import '@fontsource/atkinson-hyperlegible/700.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './features/waitlist/waitlist.css';

const root = document.getElementById('root');
if (!root) throw new Error('home.html must contain <div id="root">');

createRoot(root).render(
  <StrictMode>
    <WaitlistPage open />
  </StrictMode>,
);
